'use client'

import Button from '@shared/components/Button/Button'
import { Markdown } from '@shared/components/Markdown/Markdown'
import Text from '@shared/components/Text/Text'
import { Stack } from '@christiankaindl/lyts'
import { theme } from '@shared/styles/theme.css'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

export function getMarkdownPreview(text: string): string {
  return text
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/`([^`]+)`/g, '$1')
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
    .replace(/(\*\*|__)(.*?)\1/g, '$2')
    .replace(/(\*|_)(.*?)\1/g, '$2')
    .replace(/~~(.*?)~~/g, '$1')
    .replace(/\n+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export default function Description({
  text,
  size,
  maxLines = 2,
  isMarkdown = false,
  onReadMore,
}: {
  text: string
  size?: 'small'
  maxLines?: number
  isMarkdown?: boolean
  onReadMore?: () => void
}) {
  const t = useTranslations('Regulatory')
  const [expanded, setExpanded] = useState(false)
  const previewText = isMarkdown ? getMarkdownPreview(text) : text
  const isCustomReadMore = onReadMore !== undefined

  return (
    <Stack gap={0}>
      {expanded && isMarkdown && !isCustomReadMore ? (
        <Text
          as='div'
          color='secondary'
          size={size}
          className='[&>*:first-child]:mt-0 [&>*:last-child]:mb-0 [&_*]:text-[1em] [&_li]:leading-[inherit] [&_p]:leading-[inherit]'
        >
          <Markdown markdown={text} />
        </Text>
      ) : (
        <Text
          maxLines={expanded && !isCustomReadMore ? undefined : maxLines}
          color='secondary'
          size={size}
        >
          {previewText}
        </Text>
      )}
      <Button
        style={{
          color: theme.colors.text.brand,
          textDecoration: 'underline',
          marginLeft: -6,
        }}
        variant='flat'
        size='tiny'
        color='brand'
        onClick={() => {
          if (onReadMore) {
            onReadMore()
            return
          }
          setExpanded(!expanded)
        }}
      >
        {expanded && !isCustomReadMore ? t('readLess') : t('readMore')}
      </Button>
    </Stack>
  )
}
